module.exports = __webpack_public_path__ + "img/status-ACTIVE-icon.f3982807.svg";